<template>
	<div
		class="rounded-lg bg-[#72F761] px-1 py-0.5 text-xs font-medium text-black"
		:class="{
			'absolute -top-3 -right-2 rotate-5': rotated
		}"
		v-if="discount || bonus"
	>
		<template v-if="discount">-{{ discount }}%</template>
		<template v-if="bonus">+{{ bonus }}%</template>
	</div>
</template>
<script setup lang="ts">
defineProps<{
	discount?: number
	rotated?: boolean
	bonus?: number
}>()
</script>
